import { mapProductCompliance, RawProductCompliance } from '~/Api/CzSuklCompliance';
import mapGeneralProduct, { RawProduct as RawGeneralProduct } from '~/Api/Product/mapProduct';

import { mapReferencePrice, RawReferencePrice } from './mapReferencePrice';
import { Product } from './Product';
import { ProductDataSource } from './ProductDataSource';

export interface RawProduct {
	allowsEmptyCalculator: { exFactory: boolean };
	datasource: { type: string; suklReference: boolean };
	packageSizeForCalculation: number | null;
	packageSizeForSingleUnit: number | null;
	product: RawGeneralProduct;
	productCompliance: RawProductCompliance;
	referencePrices: RawReferencePrice[];
	selected: boolean;
	singleUnitPackageSize: boolean;
}

export function mapProduct(product: RawProduct): Product {
	return new Product(
		mapGeneralProduct(product.product),
		new ProductDataSource(product.datasource.type, product.datasource.suklReference),
		product.referencePrices.map(mapReferencePrice),
		product.packageSizeForCalculation,
		product.packageSizeForSingleUnit,
		product.singleUnitPackageSize,
		product.selected,
		mapProductCompliance(product.productCompliance)
	);
}
